import { Card, Form, FormSection, Text } from '@ksyos/design-system';
import type { IServiceOrganizationSettings } from '@common/interfaces/servicesByServiceGroupForEpisodeCategory';
import { getSelectedLanguage } from '@frontend/translate';

export interface IServiceOrganizationSettingInAddCarePathProps {
    serviceOrganizationSetting: IServiceOrganizationSettings;
}

// TODO: CS-20386 Add services that uses organizationRoles to the add carePath/add rights flow
export function ServiceOrganizationSettingInAddCarePath(props: IServiceOrganizationSettingInAddCarePathProps) {
    return (
        <Card>
            <Card.Header title={props.serviceOrganizationSetting.service.name} />
            <Card.Body>
                <Form submitOnEnter={false}>
                    <FormSection key={`${props.serviceOrganizationSetting.serviceId}`}>
                        <Text key={`${props.serviceOrganizationSetting.serviceId}-emptyList`}>
                            {getSelectedLanguage().carePath.noServiceOrganizationSettings}
                        </Text>
                    </FormSection>
                </Form>
            </Card.Body>
        </Card>
    );
}
